import React, { useEffect, useState } from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import InlineEditor from '@ckeditor/ckeditor5-build-inline';
import PropTypes from 'prop-types';
import { Paper, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import './CKEditorInline.scss';

// const ClassicEditor = require('@ckeditor/ckeditor5-editor-classic');

const CKInlineEditorField = ({
	defaultValue = '',
	onChange,
	placeholder = '',
}) => {
	const [showPlaceholder, setShowPlaceholder] = useState(false);
	const { t } = useTranslation();
	useEffect(() => {
		if (!defaultValue) {
			setShowPlaceholder(true);
		}
	}, [defaultValue]);
	return (
		<div>
			<Paper variant="outlined" className="InlineEditor">
				<Typography className="InlineEditor__placeholder">
					{showPlaceholder && `${t(placeholder)}...`}
				</Typography>
				<div className="InlineEditor__editor">
					<CKEditor
						config={{
							toolbar: [
								'bold',
								'italic',
								// 'link',
								'|',
								'undo',
								'redo',
								'|',
								'numberedList',
								'bulletedList',
							],
						}}
						placeholder="Type the content here!"
						editor={InlineEditor}
						data={defaultValue}
						onReady={() => {
							// You can store the "editor" and use when it is needed.
							// console.log('Editor is ready to use!', editor);
						}}
						onChange={(event, editor) => {
							const data = editor.getData();
							// console.log('EDITOR CHANGE: ', { event, editor, data });
							setShowPlaceholder(!data);
						}}
						onBlur={(event, editor) => {
							// console.log('Blur.', editor);
							const data = editor.getData();
							// console.log('Blur.', { event, editor, data });

							onChange(data);
						}}
						onFocus={(event, editor) => {
							console.log('Focus.', editor);
						}}
					/>
				</div>
			</Paper>
		</div>
	);
};

CKInlineEditorField.propTypes = {
	placeholder: PropTypes.string.isRequired,
	defaultValue: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
};

export default CKInlineEditorField;
